import {
  Container,
  Logo,
  Wrapper,
  FooterSection,
  FooterListContainer,
  FooterListItem,
  FooterLists,
  FooterLicense,
  FooterPayments,
  FooterPaymentTitle,
  FooterPaymentMethods,
  PaymentMethod,
  FooterSocialMedia,
  FooterCopyright,
  WrapperMobile,
  LangContainer,
  SocialMediaContainer,
  WrapperMobilePayments,
  PaymentMethodsMobile,
  LicenseMobile,
  Buttonpdf,
  Buttonpdfmovil,
  Btnonfire,
  Btnonfire2,
} from "./FooterElements";
import logo from "../../assets/images/logo.svg";
import Dropdown from "../../components/common/Dropdown";
import { useTranslation } from "react-i18next";
import { methods } from "../../const/payment-methods";
import SocialMedia from "../../components/SocialMedia";
import CustomAccordion from "../../components/CustomAccordion";
import FooterLogos from "../../components/FooterLogos";
import { Link } from "react-router-dom";
import {
  selectDetectedCountry,
  setActivePage,
} from "../../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import FoobarMobil from "../FoobarMobil/index";
/* IMPORTAMOS LOS PDFS */
import terms from "../../assets/pdfs/Terms & Conditions INGLES.pdf";
import policy from "../../assets/pdfs/AML & KYC Policy 2024.pdf";
import policy2 from "../../assets/pdfs/AML & KYC POLICY INGLES.pdf";
import responsible from "../../assets/pdfs/Responsible Gaming.pdf";
import privacy from "../../assets/pdfs/Privacy Policy.pdf";
import exclusion from "../../assets/pdfs/Self - Exclusion.pdf";
import equidad from "../../assets/pdfs/Equity & RNG.pdf";
import acc from "../../assets/pdfs/Accounts, Payments and Bonuses.pdf";
import dispute from "../../assets/pdfs/Dispute Resolution.pdf";
import terminos from "../../assets/pdfs/Términos & Condiciones 2024 version GLI.pdf";
//import privacidad from '../../assets/pdfs/Política de Privacidad.pdf';
import privacidad from "../../assets/pdfs/politica de privacidad y tratamiento de datos personales nov 2024.pdf";
import generalRules from "../../assets/pdfs/PERUVIAN SOFTWARE SOLUTIONS SAC reglas de juegos.pdf";
import { ReactComponent as Beisball } from "../../assets/icons/download-baseball.svg";
import Alrojovivo from "../../assets/images/botones-menu/alrojovivo.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPaymentMethods } from "../../utils/tools";
const Footer = () => {
  const [t, i18n] = useTranslation("global");
  const data = i18n.toJSON().store.data.es.global.footer;
  const country = useSelector(selectDetectedCountry);
  const dispatch = useDispatch();
  const [metodos, setMetodos] = useState([]);
  // const randomNumber = Math.floor(Math.random() * 1000);
  // const urlBaseball = `https://info.betsfactory.co/GacetaDelBeisbol/gacetadelbeisbol.pdf?random=${randomNumber}`;
  const urlBaseball = `https://blog.masterbets365.com`;

  const navigate = useNavigate();

  const handleClickfire = () => {
    navigate("/alrojovivo");
  };

  const handleClick = (link) => {
    dispatch(setActivePage(link));
    const scrollfooterr = document.getElementById("root");
    scrollfooterr.scrollIntoView({ behavior: "smooth" });
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(()=>{
    if(country) {
      setMetodos(getPaymentMethods(country))
    }
  },[country])



  return (
    <Container>
      <Wrapper>
        <FooterSection>
          <div className="img-container">
            <Logo src={logo} alt="MasterBets365 logo" />
          </div>
          <LangContainer>
            <FooterLogos mobile={false} />
            <Dropdown />
            {/* SOCIAL MEDIA ONLY DISPLAYS IN < 768px */}
            <SocialMediaContainer>
              <SocialMedia nav={true} />
            </SocialMediaContainer>
          </LangContainer>
          <Buttonpdfmovil>
            <a href={urlBaseball} target="_blank" rel="noreferrer">
              <p className="buttontext">{t("footer.gacetaBaseball")}</p>
              <div className="freeicon">{t("footer.gacetaNew")}</div>
            </a>
          </Buttonpdfmovil>
        </FooterSection>

        <FooterSection>
          <FooterLists>
            <FooterListContainer>
              <FooterListItem key={`list-1-title`} featured={true}>
                {t(`footer.list-1-title`)}
              </FooterListItem>
              {i18n.language !== "en" && (
                <>
                  <a href={terminos} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.0.title`)}
                    </FooterListItem>
                  </a>
                  <a href={policy} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.1.title`)}
                    </FooterListItem>
                  </a>
                  <a
                    href="https://admin.masterbets365.com/masterbets/policy/Juego Responsable.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.2.title`)}
                    </FooterListItem>
                  </a>
                  <a href={privacidad} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.3.title`)}
                    </FooterListItem>
                  </a>
                  <a
                    href="https://admin.masterbets365.com/masterbets/policy/Autoexclusión.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.4.title`)}
                    </FooterListItem>
                  </a>
                  <a
                    href="https://admin.masterbets365.com/masterbets/policy/Equidad y RNG.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.5.title`)}
                    </FooterListItem>
                  </a>
                  <a
                    href="https://admin.masterbets365.com/masterbets/policy/Cuentas, Pagos y Bonificaciones.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.6.title`)}
                    </FooterListItem>
                  </a>
                  <a
                    href="https://admin.masterbets365.com/masterbets/policy/Resolución de Conflictos.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.7.title`)}
                    </FooterListItem>
                  </a>
                </>
              )}
              {i18n.language === "en" && (
                <>
                  <a href={terms} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.0.title`)}
                    </FooterListItem>
                  </a>
                  <a href={policy2} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.1.title`)}
                    </FooterListItem>
                  </a>
                  <a href={responsible} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.2.title`)}
                    </FooterListItem>
                  </a>
                  <a href={privacy} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.3.title`)}
                    </FooterListItem>
                  </a>
                  <a href={exclusion} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.4.title`)}
                    </FooterListItem>
                  </a>
                  <a href={equidad} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.5.title`)}
                    </FooterListItem>
                  </a>
                  <a href={acc} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.6.title`)}
                    </FooterListItem>
                  </a>
                  <a href={dispute} target="_blank" rel="noreferrer">
                    <FooterListItem featured={false}>
                      {t(`footer.list-1.7.title`)}
                    </FooterListItem>
                  </a>
                </>
              )}
              {/* {
                data['list-1'].map((item, i) => 
                <Link to={t(`footer.list-1.${i}.url`)} onClick={()=>handleClick(`footer.list-1.${i}.url`)} key={`list-1-title-${i+1}`}><FooterListItem featured={false}>{t(`footer.list-1.${i}.title`)}</FooterListItem></Link>
                )
              } */}
            </FooterListContainer>
            {
              <FooterListContainer>
                <FooterListItem key={`list-2-title`} featured={true}>
                  {t(`footer.list-2-title`)}
                </FooterListItem>
                {data["list-2"].map((item, i) => (
                  <Link
                    to={t(`footer.list-2.${i}.url`)}
                    onClick={() => handleClick(`footer.list-2.${i}.url`)}
                    key={`list-2-title-${i + 1}`}
                  >
                    <FooterListItem featured={false}>
                      {t(`footer.list-2.${i}.title`)}
                    </FooterListItem>
                  </Link>
                ))}
              </FooterListContainer>
            }
            <FooterListContainer>
              <FooterListItem key={`list-3-title`} featured={true}>
                {t(`footer.list-3-title`)}
              </FooterListItem>
              {data["list-3"].map((item, i) => (
                <Link
                  to={t(`footer.list-3.${i}.url`)}
                  onClick={() => handleClick(`footer.list-3.${i}.url`)}
                  key={`list-3-title-${i + 1}`}
                >
                  <FooterListItem featured={false}>
                    {t(`footer.list-3.${i}.title`)}
                  </FooterListItem>
                </Link>
              ))}
            </FooterListContainer>
            <FooterListContainer>
              <FooterListItem key={`list-4-title`} featured={true}>
                {t(`footer.list-4-title`)}
              </FooterListItem>
              {data["list-4"].map((item, i) => (
                <Link
                  key={`list-4-title-${i + 1}`}
                  to={t(`footer.list-4.${i}.url`)}
                  onClick={() => handleClick(`footer.list-4.${i}.url`)}
                >
                  <FooterListItem featured={false}>
                    {t(`footer.list-4.${i}.title`)}
                  </FooterListItem>
                </Link>
              ))}
              <div>
                <a href={generalRules} target="_blank" rel="noreferrer">
                  <FooterListItem featured={false}>
                    Reglamentos Generales
                  </FooterListItem>
                </a>
              </div>
            </FooterListContainer>
          </FooterLists>
          <FooterLicense>
            {country !== "PE" && (
              <>
                <p>
                  {t("footer.lic-1")
                    .split("MasterBets365.com")
                    .map((part, index) =>
                      index === 0 ? (
                        <span key={`part-${index}`}>{part}</span>
                      ) : (
                        <span key={`part-${index}`}>
                          <a
                            href="https://masterbets365.com"
                            target="_blank"
                            rel="noreferrer"
                            style={{ color: "#FFCE05" }}
                          >
                            MasterBets365.com
                          </a>{" "}
                          {part}
                        </span>
                      )
                    )}
                </p>
                <p>
                  {t("footer.lic-4")
                    .split("<a>")
                    .map((el, i) =>
                      i !== 1 ? (
                        el
                      ) : (
                        <a
                          href={i18n.language === "en" ? terms : terminos}
                          target="_blank"
                          rel="noreferrer"
                          style={{ color: "#FFCE05" }}
                        >
                          {el}
                        </a>
                      )
                    )}
                </p>
                <p>
                  {t("footer.lic-3")
                    .split("MasterBets365.com")
                    .map((part, index) =>
                      index === 0 ? (
                        <span key={`part-${index}`}>{part}</span>
                      ) : (
                        <span key={`part-${index}`}>
                          <a
                            href="https://masterbets365.com"
                            target="_blank"
                            rel="noreferrer"
                            style={{ color: "#FFCE05" }}
                          >
                            MasterBets365.com
                          </a>{" "}
                          {part}
                        </span>
                      )
                    )}
                </p>
                <p>
                  {t("footer.lic-2")
                    .split("masterbets365.com")
                    .map((part, index) =>
                      index === 0 ? (
                        <span key={`part-${index}`}>{part}</span>
                      ) : (
                        <span key={`part-${index}`}>
                          <a
                            href="https://masterbets365.com"
                            target="_blank"
                            rel="noreferrer"
                            style={{ color: "#FFCE05" }}
                          >
                            MasterBets365.com
                          </a>{" "}
                          {part}
                        </span>
                      )
                    )}
                </p>

                <p>
                  {t("footer.lic-5")
                    .split("https://masterbets365.com")
                    .map((part, index) =>
                      index === 0 ? (
                        <span key={`part-${index}`}>{part}</span>
                      ) : (
                        <span key={`part-${index}`}>
                          <a
                            href="https://masterbets365.com"
                            target="_blank"
                            rel="noreferrer"
                            style={{ color: "#FFCE05" }}
                          >
                            https://masterbets365.com
                          </a>
                          {part}
                        </span>
                      )
                    )}
                </p>
              </>
            )}

            {country === "PE" && (
              <>
                <p style={{ lineHeight: "1.5" }}>
                  La plataforma{" "}
                  <a
                    href="https://masterbets365.com"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#FFCE05" }}
                  >
                    https://masterbets365.com
                  </a>{" "}
                  es operada en Perú por{" "}
                  <span style={{ fontWeight: "bold" }}>
                    PERUVIAN SOFTWARE SOLUTIONS S.A.C.
                  </span>{" "}
                  identificada con RUC 20611164476, autorizada para la
                  jurisdicción de la República del Perú, bajo licencias{" "}
                  <span style={{ fontWeight: "bold" }}>
                    # 2151-2024-MINCETUR/VMT/DGJCMT
                  </span>{" "}
                  y{" "}
                  <span style={{ fontWeight: "bold" }}>
                    # 2098-2024-MINCETUR/VMT/DGJCMT
                  </span>{" "}
                  emitidas por el Ministerio de Comercio Exterior y Turismo -
                  MINCETUR, para la explotación de los juegos y apuestas
                  deportivas a distancia, respectivamente, sujeto a los términos
                  y condiciones de este sitio.
                </p>
              </>
            )}

            <br></br>
            <p>{t("footer.lic-7")}</p>
          </FooterLicense>
        </FooterSection>

        <FooterPayments>
          <FooterPaymentTitle>{t("footer.payment")}</FooterPaymentTitle>
          <FooterPaymentMethods>
            {metodos.length>7 ?
            <Slider {...settings}>
            {metodos?.map((item, i) => (
                <PaymentMethod
                  key={`method-${i + 1}`}
                  width={item.width}
                  height={item.height}
                >
                  <img src={item.src} alt={item.name} />
                </PaymentMethod>
              ))}
          </Slider>
             : <div style={{ display: "flex", justifyContent: "center" }}>
             {metodos?.map((item, i) => (
                 <PaymentMethod
                   className="pe"
                   key={`method-${i + 1}`}
                   width={item.width}
                   height={item.height}
                 >
                   <img src={item.src} alt={item.name} />
                 </PaymentMethod>
               ))}
           </div>
             }
            
            
          </FooterPaymentMethods>
        </FooterPayments>

        {/* MOBILE CUSTOM STYLES */}
        <WrapperMobile>
          <CustomAccordion data={data} t={t} />
        </WrapperMobile>

        <WrapperMobilePayments>
          <FooterPaymentTitle>{t("footer.payment")}</FooterPaymentTitle>
          <PaymentMethodsMobile>
            
              {metodos?.map((paym,i)=>(<PaymentMethod
                    key={"method-"+i}
                    index={i}
                    width={paym.width}
                    height={paym.height}
                  >
                    <img src={paym.src} alt={paym.name} style={{width: paym.width, height: paym.height}} />
                  </PaymentMethod>))}
              
          </PaymentMethodsMobile>
        </WrapperMobilePayments>

        <LicenseMobile>
          <p>
            {t("footer.lic-1")
              .split("MasterBets365.com")
              .map((part, index) =>
                index === 0 ? (
                  <span key={`part-${index}`}>{part}</span>
                ) : (
                  <span key={`part-${index}`}>
                    <a
                      href="https://masterbets365.com"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#FFCE05" }}
                    >
                      MasterBets365.com
                    </a>{" "}
                    {part}
                  </span>
                )
              )}
          </p>
          <p>
            {t("footer.lic-4")
              .split("<a>")
              .map((el, i) =>
                i !== 1 ? (
                  el
                ) : (
                  <a
                    href={i18n.language === "en" ? terms : terminos}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#FFCE05" }}
                  >
                    {el}
                  </a>
                )
              )}
          </p>
          <p>
            {t("footer.lic-3")
              .split("MasterBets365.com")
              .map((part, index) =>
                index === 0 ? (
                  <span key={`part-${index}`}>{part}</span>
                ) : (
                  <span key={`part-${index}`}>
                    <a
                      href="https://masterbets365.com"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#FFCE05" }}
                    >
                      MasterBets365.com
                    </a>{" "}
                    {part}
                  </span>
                )
              )}
          </p>
          <p>
            {t("footer.lic-2")
              .split("masterbets365.com")
              .map((part, index) =>
                index === 0 ? (
                  <span key={`part-${index}`}>{part}</span>
                ) : (
                  <span key={`part-${index}`}>
                    <a
                      href="https://masterbets365.com"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#FFCE05" }}
                    >
                      MasterBets365.com
                    </a>{" "}
                    {part}
                  </span>
                )
              )}
          </p>

          <p>
            {t("footer.lic-5")
              .split("https://masterbets365.com")
              .map((part, index) =>
                index === 0 ? (
                  <span key={`part-${index}`}>{part}</span>
                ) : (
                  <span key={`part-${index}`}>
                    <a
                      href="https://masterbets365.com"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#FFCE05" }}
                    >
                      https://masterbets365.com
                    </a>
                    {part}
                  </span>
                )
              )}
          </p>
          <br></br>
          <p>{t("footer.lic-7")}</p>
        </LicenseMobile>

        <FooterSection>
          <FooterLogos mobile={true} />
          <FooterCopyright>
            Copyright © 2024 MasterBets365 All rights reserved.
          </FooterCopyright>
          <FooterSocialMedia>
            <p>{t("footer.follow-us")}</p>
            <SocialMedia />
          </FooterSocialMedia>
          <Buttonpdf>
            <a href={urlBaseball} target="_blank" rel="noreferrer">
              <p className="buttontext">{t("footer.gacetaBaseball")}</p>
              <div className="freeicon">{t("footer.gacetaNew")}</div>
            </a>
          </Buttonpdf>
          <FooterCopyright responsive={true}>
            Copyright © 2024 MasterBets365 All rights reserved.
          </FooterCopyright>
        </FooterSection>
      </Wrapper>
      <FoobarMobil></FoobarMobil>
      {/* <Btnonfire onClick={handleClickfire}>
        <div class="flames">
          <div class="flame"></div>
          <div class="flame"></div>
          <div class="flame"></div>
          <div class="flame"></div>
        </div>
        <p className='textflame' style={{backgroundImage:`url(${Alrojovivo})`}}>{t('footer.alrojovivo')}</p>
      </Btnonfire>*/}
      {/* segunda version de "al rojo vivo" */}
      {/* <Btnonfire2 to="#">
        <div class="fire-left">
          <div class="main-fire"></div>
          <div class="particle-fire"></div>
        </div>
        <div class="fire-center">
          <div class="main-fire"></div>
          <div class="particle-fire"></div>
        </div>
        <div class="fire-right">
          <div class="main-fire"></div>
          <div class="particle-fire"></div>
        </div>
        <div class="fire-bottom">
          <div class="main-fire"></div>
        </div>
        <p className='textflame'>AL ROJO VIVO</p>
      </Btnonfire2> */}
    </Container>
  );
};

export default Footer;
